// extracted by mini-css-extract-plugin
export default {"helper-text":"Kj98Hqg8 RkcgEdnc"};